import React from 'react';
import { Autocomplete, Box, Chip, TextField } from '@mui/material';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import { inputSx, menuPaperSx, valueChipSx } from './orgSettingsStyles';
import { MOBILE_SX } from '../../../../mobile/mobileApp';

// Inputs shared by the Organization Settings cards.

// A dropdown option: its label, with a check on the right once chosen.
export const renderCheckOption = (
  props: React.HTMLAttributes<HTMLLIElement>,
  label: React.ReactNode,
  selected: boolean,
  key: string
) => (
  <li {...props} key={key}>
    <Box
      sx={{
        flex: 1,
        minWidth: 0,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        // A phone: a long option wraps rather than being cut.
        [MOBILE_SX]: { whiteSpace: 'normal', overflowWrap: 'anywhere' }
      }}
    >
      {label}
    </Box>
    {selected && <CheckRoundedIcon sx={{ fontSize: 18, color: '#F79420', ml: 1, flexShrink: 0 }} />}
  </li>
);

export const popupIcon = <KeyboardArrowDownRoundedIcon />;
export const chipDeleteIcon = <CloseRoundedIcon />;

// The values of an attribute list: pick from its values or type a new one and
// press Enter. Chosen values show as chips.
export const ValuesInput: React.FC<{
  options: string[];
  value: string[];
  placeholder: string;
  onChange: (values: string[]) => void;
  testId?: string;
}> = ({ options, value, placeholder, onChange, testId }) => (
  <Autocomplete
    multiple
    freeSolo
    forcePopupIcon
    popupIcon={popupIcon}
    options={options}
    value={value}
    onChange={(_event, next) => onChange(next as string[])}
    componentsProps={{ paper: { sx: menuPaperSx } }}
    sx={inputSx}
    renderOption={(props, option, { selected }) => renderCheckOption(props, option, selected, option)}
    renderTags={(tags, getTagProps) =>
      tags.map((option, index) => (
        <Chip {...getTagProps({ index })} key={option} label={option} deleteIcon={chipDeleteIcon} sx={valueChipSx} />
      ))
    }
    renderInput={(params) => (
      <TextField
        {...params}
        size="small"
        placeholder={value.length ? '' : placeholder}
        fullWidth
        inputProps={{ ...params.inputProps, 'data-testid': testId }}
      />
    )}
  />
);
